// Header.js
import React, { Component } from 'react';
import queryString from 'query-string';
import { SERVER_URL } from './ServerConfig'

export default class NavBar extends Component {

    constructor(props) {
        super(props);

        let params = queryString.parse(this.props.location.search);
        this.state = {
            params : params,
            station : null
        }
    }

    componentDidMount() {
        this.fetchStation();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.station && nextProps.station._id) {
            this.setState({station : nextProps.station});
        }
    }

    fetchStation() {
        let stationId = this.state.params.station;
        if (!stationId) {
            return;
        }
        let token = this.props.user.payload.token;
        fetch(SERVER_URL + '/v1/stations/' + stationId, {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data && data.success) {
                    this.setState({station : data.content})
                }
            });
    }

    getSystemNotification() {
        if (this.state.station && !this.state.station.mSupportChangePowerOutput) {
            return (
                <span className="ml-4">
                    <div className="d-flex align-items-center header-callout p-1 pl-2 pr-2">
                        <span className="badge bg-danger">New</span>
                        <div className="ml-2">
                            Remote power limit function is now available, please <a target="_blank" href="https://drive.google.com/file/d/1ccrMjx5Nyo7VE_fkMsuohSqkYFqRYcOJ/view?usp=sharing">contact</a> system admin to activate
                        </div>
                    </div>
                </span>
            )
        }
    }

    render() {
        let user = this.props.user.payload.user;
        if (!user.member) {
            return (
                <div></div>
            )
        }
        let station = this.state.station;
        let stationName = station ? station.mName : "";
        return (
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#"><i className="fas fa-bars"></i></a>
                    </li>
                </ul>

                <div className="d-flex align-items-center">
                    <h4 className="ml-2">
                        {stationName}
                    </h4>
                </div>
                {this.getSystemNotification()}
            </nav>
        )
    }
}